import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inner" }
const _hoisted_2 = { class: "front content" }
const _hoisted_3 = { class: "back content" }

import {
  useToggle,
  useMProp,
  useProp,
  usePrioritizeFlags,
} from "@toolsie/composables";
//import props
import propsObject from "@/props/baseFlipper";
import { BaseFlipperProps } from "@/typings/baseFlipper";
//import vue
import { computed } from "vue";

//define the props

//import components
import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "BaseFlipper",
  inheritAttrs: true,
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: propsObject,
  emits: ["update:flipped"],
  setup(__props, { emit: emits }: { emit: ({ (e: "update:flipped", value: boolean): void }), expose: any, slots: any, attrs: any }) {

const props: BaseFlipperProps = __props;

//import composables

//define emits


//the active trigger is the trigger prop
let active = useMProp(props, "flipped", false, emits, "update:flipped");
let horizontal = useProp(props, "horizontal", false);
let vertical = useProp(props, "vertical", false);

//obtain the default state
let state = usePrioritizeFlags(
  "horizontal",
  { horizontal: horizontal },
  { vertical: vertical }
);

//get the toggler for the active value
let { toggle } = useToggle(active);

//compute the classes
let classes = computed(() => ({
  /** the flipping is vertical */
  vertical: state.value == "vertical",
  /** the flipping is vertical */
  horizontal: state.value == "horizontal",
  /** the flipping is on hover */
  hover: props.hover,
  /** the flipping on click is currently active */
  active: active.value,
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps({
    class: ["toolsie flipper container", _unref(classes)]
  }, _ctx.$attrs, {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.click ? _unref(toggle)() : {}))
  }), [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "front")
      ]),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "back")
      ])
    ])
  ], 16))
}
}

})